import { render } from "./Collection.vue?vue&type=template&id=917e7080"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "917e7080"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('917e7080', script)) {
    api.reload('917e7080', script)
  }
  
  module.hot.accept("./Collection.vue?vue&type=template&id=917e7080", () => {
    api.rerender('917e7080', render)
  })

}

script.__file = "src/icons/components/filled/Collection.vue"

export default script